import React, { useState } from "react";
import "./VideoPage.css";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import VideoTitle from "./VideoTitle";

import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import VideoCardList from "./VideoCardList";
import SingleVideoLeft from "./SingleVideoLeft";
import SingleVideoRight from "./SingleVideoRight";

const VideoPage = (props) => {
  const videoData = props.location && props.location.state;

  const {
    url = "https://www.youtube.com/embed/bHWgc5MPnPA",
    title = "Default Video Title",
    category = "Default Track • Date",
    totalvideos = "0",
    relatedVideos = [] // 👈 expect this from RacesVideos.js
  } = videoData || {};

  const [videoSrc, setVideoSrc] = useState(url);

  const handleVideoSelect = (videoUrl) => {
    setVideoSrc(videoUrl);
  };

  return (
    <ContentWrapper>
      <Container fluid>
        {/* Main video + right sidebar */}
        <div className="video-block-right-list section-padding">
          <Row className="mb-4">
            <Col md={8}>
              <div className="single-video">
                <iframe
                  title="Youtube Video"
                  width="100%"
                  height="315"
                  src={videoSrc}
                  frameBorder="0"
                  allow="encrypted-media"
                  allowFullScreen
                ></iframe>
              </div>
            </Col>

            <Col md={4}>
              <div className="video-slider-right-list">
                {relatedVideos.length > 0 ? (
                  relatedVideos.map((video, i) => (
                    <VideoCardList
                      key={i}
                      imgSrc={video.imgSrc || "img/v1.png"}
                      time={video.time || "3:50"}
                      videoTitle={video.title}
                      views={video.category}
                      verified={video.verified}
                      onClick={() => handleVideoSelect(video.url)}
                    />
                  ))
                ) : (
                  <p>No related videos available</p>
                )}
              </div>
            </Col>
          </Row>
        </div>

        {/* Video Title + Extra Info Section */}
        <div className="video-block section-padding">
          <Row>
            <Col md={8}>
              <div className="single-video-left">
                <VideoTitle title={title} views={category} />
              </div>
            </Col>
            <Col md={4}>
              <SingleVideoRight />
            </Col>
          </Row>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default VideoPage;
